import { EMPTY } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { utilBugSnag } from "../../utils/utilBugSnag";
import { TypeActionAnimations } from "../animation/actionPelletAnimations";
import { TypeActionGameTracking } from "../game-tracking/actionGameTracking";
import { TypeActionOutskirtsInfo } from "../info/outskirts/actionOutskirtsInfo";
import { TypeActionPlayerInfo } from "../info/player/actionPlayerInfo";
import { TypeActionProductionInfo } from "../info/production/actionProductionInfo";
import { TypeActionQuestInfo } from "../info/quest/actionQuestInfo";
import { TypeActionLoading } from "../loading/actionLoading";
import { TypeActionContractInfo } from "../market/actionContractInfo";
import { TypeActionModal } from "../modals/actionModal";
import { TypeActionBuildings } from "../player-base/buildings/actionBuildings";
import { TypeActionTooltip } from "../tooltip/actionTooltip";
import { TypeActionViewport } from "../viewport/actionViewport";
export var epicBugsnag = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return ([
            TypeActionAnimations.AddPellets,
            TypeActionAnimations.AddPelletsInScreenCenter,
            TypeActionAnimations.AddPelletsOnContractFulfill,
            TypeActionAnimations.RemovePellets,
            TypeActionBuildings.AddPellets,
            TypeActionBuildings.Deselect,
            TypeActionBuildings.PreSelect,
            TypeActionBuildings.Select,
            TypeActionBuildings.RewriteCenter,
            TypeActionContractInfo.Received,
            TypeActionGameTracking.UpdateTracking,
            TypeActionLoading.Complete,
            TypeActionLoading.Progress,
            TypeActionModal.Close,
            TypeActionOutskirtsInfo.DeselectOutskirtBuilding,
            TypeActionPlayerInfo.AddXp,
            TypeActionProductionInfo.PreCollect,
            TypeActionQuestInfo.Update,
            TypeActionTooltip.Hide,
            TypeActionTooltip.HideBuildingTooltipText,
            TypeActionTooltip.Show,
            TypeActionTooltip.ShowBuildingTooltipText,
            TypeActionViewport.CenterOn,
            TypeActionViewport.ClearCenter,
            TypeActionViewport.RequestClearCenter,
            TypeActionViewport.SmoothZoom,
            TypeActionViewport.ZoomIn,
            TypeActionViewport.ZoomOut,
        ].indexOf(action.type) === -1);
    }), switchMap(function (action) {
        utilBugSnag.addActionBugsnagBreadcrumb(action);
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/bugsnag/epicBugsnag.ts
// module id = 1786
// module chunks = 3